import { createEnum } from '../actionTypesHelpers';

export const sortDirection = createEnum({
  Ascending: 'asc',
  Descending: 'desc',
});
